import React from 'react';
import './Popular.css';
import Item from '../Item/Item';
import { products } from '../../data/products';

const Popular = () => {
    const popularProducts = products.filter(item => item.category === 'living').slice(0, 4);

    return (
        <div className='popular'>
            <div className="popular-header">
                <h2>Featured Collection</h2>
                <p>Discover our most loved pieces</p>
            </div>

            <div className="popular-item">
                {popularProducts.map((item, i) => {
                    return <Item key={i} id={item.id} name={item.name} image={item.image} new_price={item.new_price} old_price={item.old_price}/>
                })}
            </div>
        </div>
    )
}

export default Popular
